// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/@vue/cli-service/node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".head-menu{width:100%;background:#f2f2f2;height:36px;line-height:36px}.head-menu .public-width{font-size:12px}.head-menu .public-width .right{text-align:end}.head-menu .public-width .right .ant-dropdown-link{color:#999;margin-right:20px}.head-menu .public-width .right .ant-dropdown-color{color:#0b8cf9}", ""]);
// Exports
module.exports = exports;
